import React, { useEffect, useRef } from 'react';
import Portal from '../../../../shared/Portal';
import { ReactComponent as CloseIcon } from '../images/close_icon.svg';
import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 1000;
  overflow: auto;
  background: rgba(9, 21, 38, 0.35);
`;

export const WrapModal = styled.div`
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 16px;
  width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ContentainerModal = styled.div`
  padding: 40px 24px;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const CloseIconWrap = styled.div`
  position: absolute;
  top: 0px;
  right: -32px;
  cursor: pointer;
`;

const body = document.querySelector('body');

const ModalContainer = (props: React.PropsWithChildren<{ onClose: () => void }>) => {
  const mousedownTarget = useRef<EventTarget>();
  const mouseupTarget = useRef<EventTarget>();
  const handleClose = () => {
    props.onClose && props.onClose();
  };

  const handleEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape') handleClose();
  };

  const handleClickOverlay = (e: React.MouseEvent) => {
    if (e.type === 'mousedown') {
      mousedownTarget.current = e.target;
    } else if (e.type === 'mouseup') {
      mouseupTarget.current = e.target;
    } else if (e.currentTarget === mousedownTarget.current && e.currentTarget === mouseupTarget.current) {
      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    body?.classList.add('noScrollBody');
    return () => {
      document.removeEventListener('keydown', handleEscape);
      body?.classList.remove('noScrollBody');
    };
  }, [handleEscape]);

  return (
    <Portal>
      <Overlay onMouseUp={handleClickOverlay} onMouseDown={handleClickOverlay} onClick={handleClickOverlay}>
        <WrapModal>
          <CloseIconWrap>
            <CloseIcon onClick={handleClose} />
          </CloseIconWrap>
          <ContentainerModal>
            <ContentModal>{props.children}</ContentModal>
          </ContentainerModal>
        </WrapModal>
      </Overlay>
    </Portal>
  );
};

export default ModalContainer;
